<template>
    <div :class="skeleton">
        <div class="h-[166px] bg-gray-850 rounded-[4px]"></div>
        <div class="w-24 h-4 bg-gray-850 rounded-full"></div>
        <div class="w-[90%] h-4 bg-gray-850 rounded-full"></div>
        <div class="w-16 h-4 bg-gray-850 rounded-full"></div>
    </div>
</template>
<script lang="ts" setup>
import { cva } from "class-variance-authority";

interface Props {
    size: "sm" | "md" | "lg" | "xl";
}
const skeleton = computed(() => {
    return cva(" loading p-4 flex flex-col space-y-4 rounded-lg bg-gray-900 ", {
        variants: {
            size: {
                sm: "h-[241px]",
                md: "h-[241px]",
                lg: "h-[291px] w-[198px]",
            },
        },
        defaultVariants: { size: "lg" },
    })({
        size: props.size,
    });
});

const props = defineProps<Props>();
</script>
